import React from 'react';
import injectSheet from 'react-jss';
import Select from 'react-select';
import { countries } from '../../../utils/select-fields';

const SearchLocation = ({ companyType, onChange, value, classes: css }) => {
  const countryLabelText = {
    Supplier: 'Located in:',
    DMOs: 'That promote destinations in:',
  }[companyType] || 'That sell trips to:';
  return (
    <div className={css.wrapper}>
      <div className="label-text-left-nav" style={{ textAlign: 'left', whiteSpace: 'pre-wrap', margin: '-10px 0 0 15px' }}>
        {countryLabelText}
      </div>
      <Select
        className={css.countrySelect}
        onChange={({ value: val }) => onChange(val)}
        options={countries}
        value={value}
        placeholder="Search & Pick A Country"
        clearable={false}
        scrollMenuIntoView={false}
      />
    </div>
  );
};

export default injectSheet({
  wrapper: {
    margin: '10px 0 10px 0',
  },
  countrySelect: {
    margin: '5px 0 15px 15px',
    width: '90%',
    '& div': {
      borderLeft: 'none !important',
      borderRight: 'none !important',
      borderTop: 'none !important',
    },
  },
})(SearchLocation);



// WEBPACK FOOTER //
// ./src/app/components/partner-finder/search-widgets/search-location.jsx